import { styled, Switch, switchClasses } from "@mui/material";

export const OrangeSwitch = styled(Switch)(({ theme }) => ({
  width: 40, // reduced from 52
  height: 22, // reduced from 28
  padding: 0,
  display: "inline-flex",
  alignItems: "center",

  [`& .${switchClasses.switchBase}`]: {
    padding: 2,
    transitionDuration: "200ms",
    [`&.${switchClasses.checked}`]: {
      transform: "translateX(18px)", // adjusted for new width
      color: "#fff",
      [`& + .${switchClasses.track}`]: {
        backgroundColor: "#F57C21", // orange (ON)
        opacity: 1,
      },
    },
  },

  [`& .${switchClasses.thumb}`]: {
    width: 18, // reduced from 24
    height: 18, // reduced from 24
    boxShadow: "0 1px 2px rgba(0,0,0,0.25)",
    backgroundColor: "#fff",
  },

  [`& .${switchClasses.track}`]: {
    borderRadius: 999,
    backgroundColor: "#E5E7EB", // gray (OFF)
    opacity: 1,
    boxSizing: "border-box",
  },

  [`& .${switchClasses.switchBase}.${switchClasses.focusVisible} .${switchClasses.thumb}`]:
    { boxShadow: `0 0 0 3px rgba(245,124,33,0.35)` },
}));
